export const StartAiProcessDrawerTestIds = {
  CONTAINER: 'StartAiProcessDrawer_Container',
  SEARCH_INPUT: 'StartAiProcessDrawer_SearchInput',
  PROCESS_LIST: 'StartAiProcessDrawer_ProcessList',
  PROCESS_CARD: 'StartAiProcessDrawer_ProcessCard',
  START_BUTTON: 'StartAiProcessDrawer_StartButton',
  RUNNING_OPEN_LINK: 'StartAiProcessDrawer_RunningOpenLink',
  EMPTY_STATE: 'StartAiProcessDrawer_EmptyState',
  LOADING: 'StartAiProcessDrawer_Loading',
  SUBJECT_STEP: 'StartAiProcessDrawer_SubjectStep',
  SUBJECT_BACK_BUTTON: 'StartAiProcessDrawer_SubjectBackButton',
  SUBJECT_CERT_OPTION: 'StartAiProcessDrawer_SubjectCertOption',
  SUBJECT_START_BUTTON: 'StartAiProcessDrawer_SubjectStartButton',
};
